export default "__VITE_ASSET__DHVtGAQQ__"